import { render, staticRenderFns } from "./detalhes-outros.vue?vue&type=template&id=a9dd6098&scoped=true&"
import script from "./detalhes-outros.vue?vue&type=script&lang=js&"
export * from "./detalhes-outros.vue?vue&type=script&lang=js&"
import style0 from "../styles/report.scss?vue&type=style&index=0&id=a9dd6098&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9dd6098",
  null
  
)

export default component.exports